import { render } from "./StoreShoppingCart.vue?vue&type=template&id=86bb0f50&scoped=true"
import script from "./StoreShoppingCart.vue?vue&type=script&lang=js"
export * from "./StoreShoppingCart.vue?vue&type=script&lang=js"

import "./StoreShoppingCart.vue?vue&type=style&index=0&id=86bb0f50&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86bb0f50"]])

export default __exports__